module.exports = __webpack_public_path__ + "static/img/edit.08e3023d.svg";